import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Wordmark } from "./Header";
import { SERVICES } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-white">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Wordmark light />
          <p className="mt-5 text-sm font-semibold tracking-wide text-white/90">
            From Language to Leadership.
          </p>
          <p className="mt-2 text-sm leading-relaxed text-white/60">
            Bridging Cultures in International Education.
          </p>
        </div>

        <nav aria-label="Footer navigation" data-testid="footer-nav">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/50">
            Navigate
          </p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              ["/", "Home"],
              ["/expertise", "Expertise"],
              ["/experience", "Experience"],
              ["/insights", "Insights"],
              ["/about", "About"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  className="text-white/75 transition-colors duration-300 hover:text-white"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Expertise navigation" data-testid="footer-expertise-nav">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/50">
            Expertise
          </p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/expertise/${s.slug}`}
                  className="text-white/75 transition-colors duration-300 hover:text-white"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/50">
            Enquiries
          </p>
          <p className="mt-4 text-sm leading-relaxed text-white/60">
            Every enquiry is read personally and answered directly.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta-link"
            className="group mt-4 inline-flex items-center gap-2 text-sm font-bold text-white"
          >
            <span className="border-b border-white/40 pb-0.5 transition-colors duration-300 group-hover:border-white">
              Let's Connect
            </span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/15 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} English for Leaders. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-white">
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-white">
            Terms
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
